import { useState } from 'react'
import ItemTabs from 'components/ItemTabs'
import AccessLevels from './AccessLevels'
import ChangePassword from './ChangePassword'
import { Container } from '../styles'

function EditProfessionalSecurity ({
  professional,
  onValidationPermissionUpdated: handleValidationPermissionUpdated
}) {
  const [option, setOption] = useState ('permissions')

  const OPTION_LIST = [
    {
      label: 'Permissões',
      value: 'permissions',
      component: <AccessLevels
        professional={professional}
        onValidationPermissionUpdated={handleValidationPermissionUpdated}
      />
    },
    {
      label: 'Alterar senha',
      value: 'change_password',
      component: <ChangePassword professional={professional}/>
    }
  ]

  return (
    <Container style={{paddingTop: 0}}>
      <ItemTabs
        tabs={OPTION_LIST}
        selectedTab={option}
        onTabChange={setOption}
        containerStyle={{paddingTop: 7}}
        tabWidth={150}
      />
      {OPTION_LIST.find (o => o.value === option).component}
    </Container>
  )
}

export default EditProfessionalSecurity
